/**
 * Shared base for backend API services.
 * Derived services get the common API client and app store access here.
 * Editor/canvas logic should not be added to this layer.
 */
import type { ApiClient } from '@/api/index';
import apiClient, { stunnrAiApiClient, idpApiClient } from '@/api/index';
import appConfig from '@/constants/appConfig';
import { useAppStore } from '@/stores/app';
import { LANGFUSE_PROJECT_IDS } from '@/constants/langfuseProjects';

class BaseService {
  apiClient: ApiClient;
  aiApiClient: ApiClient;
  idpApiClient: ApiClient;

  constructor() {
    this.apiClient = apiClient;
    this.aiApiClient = stunnrAiApiClient;
    this.idpApiClient = idpApiClient;
  }

  get appStore(): ReturnType<typeof useAppStore> {
    return useAppStore();
  }

  protected buildAiTraceHeaders(
    projectId?: string | number | null
  ): Record<string, string> {
    const headers: Record<string, string> = {
      'trace-session-id': crypto.randomUUID(),
      'x-client-app': appConfig.CLIENT_APP
    };

    const portalId = this.appStore.portalData?.id;
    if (portalId != null) headers['portal-id'] = String(portalId);
    if (projectId != null) headers['langfuse-project-id'] = String(projectId);

    return headers;
  }

  /** Request options carrying the Stunnr-project Langfuse trace headers. */
  protected stunnrTraceOptions() {
    return { headers: this.buildAiTraceHeaders(LANGFUSE_PROJECT_IDS.STUNNR) };
  }
}

export default BaseService;
